import { JSONable } from '@irian-ro/abstract-resource';
import { ShipmentDriverDtoModel } from './shipment-driver-dto.model';
import { ShipmentVehicleDtoModel } from './shipment-vehicle-dto.model';

export class ShipmentRoutingDtoModel extends JSONable {
  shipmentDriverDTO: ShipmentDriverDtoModel | null = new ShipmentDriverDtoModel();
  shipmentVehicleDTO: ShipmentVehicleDtoModel | null = new ShipmentVehicleDtoModel();
}
